'use client'

import { useState, useEffect } from 'react'
import { X, AlertCircle } from 'lucide-react'
import { Button } from '@/components/ui/button'

const MAINTENANCE_END = new Date('2026-05-21T06:00:00+06:00')

export function MaintenanceBanner() {
    const [isVisible, setIsVisible] = useState(true)
    const [timeLeft, setTimeLeft] = useState(() =>
        Math.max(0, Math.floor((MAINTENANCE_END.getTime() - Date.now()) / 1000))
    )

    useEffect(() => {
        if (timeLeft <= 0) {
            setIsVisible(false)
            return
        }

        const timer = setInterval(() => {
            const secs = Math.max(0, Math.floor((MAINTENANCE_END.getTime() - Date.now()) / 1000))
            setTimeLeft(secs)
            if (secs <= 0) setIsVisible(false)
        }, 1000)

        return () => clearInterval(timer)
    }, [])

    const formatTime = (seconds: number) => {
        const hrs = Math.floor(seconds / 3600)
        const mins = Math.floor((seconds % 3600) / 60)
        const secs = seconds % 60
        return `${hrs}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
    }

    if (!isVisible) return null

    return (
        <div className="bg-primary text-primary-foreground shadow-md border-b border-primary-foreground/10">
            <div className="container mx-auto px-4 py-2.5">
                <div className="flex items-center justify-between gap-4">
                    <div className="flex items-center gap-3 flex-1">
                        <div className="bg-primary-foreground/10 p-1.5 rounded-lg">
                            <AlertCircle className="w-4 h-4 flex-shrink-0" />
                        </div>
                        <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3">
                            <p className="text-sm font-bold tracking-tight">
                                SYSTEM UPDATE
                            </p>
                            <span className="hidden sm:inline-block w-1.5 h-1.5 rounded-full bg-primary-foreground/20" />
                            <p className="text-sm opacity-90 font-medium">
                                We're performing scheduled maintenance. Some features may be briefly unavailable.
                            </p>
                        </div>
                    </div>
                    <div className="flex items-center gap-4">
                        <div className="bg-primary-foreground/10 backdrop-blur-sm px-3 py-1 rounded-full border border-primary-foreground/20 flex items-center gap-2">
                            <span className="text-[10px] font-bold uppercase tracking-wider opacity-70">Remaining</span>
                            <span className="text-sm font-mono font-bold">{formatTime(timeLeft)}</span>
                        </div>
                        <Button
                            variant="ghost"
                            size="icon"
                            className="h-7 w-7 text-primary-foreground hover:bg-primary-foreground/10 rounded-full"
                            onClick={() => setIsVisible(false)}
                        >
                            <X className="w-4 h-4" />
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}
